export const ANNOUNCEMENTS = 'announcements';
export const COMMON_ROOM = 'commonRoom';

export const TITLE = Object.freeze({
  ANNOUNCEMENTS: 'Announcements',
  COMMON_ROOM: 'Common Room',
});
